import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CompanyService } from 'app/company/services/company.service';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/core/services/user.service';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { ActivatedRoute } from '@angular/router';
import { CompanyUserListModel } from 'app/company/models/company-user-list-model';
import { CompanyDetailsModel } from 'app/company/models/company-details-model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';
import { UserType } from '../../../account/models/user-type.model';
import { CompanyUser } from '../../../account/models/company-user.model';
import { Result } from 'app/core/models/result';
import { User } from '../../../shared/models/User';
import { CompanyUserModel } from '../../../shared/models/company-user.model';
import { LendersService } from '../../../lenders/services/lenders.service';
import { LendersModel } from '../../../lenders/models/lenders.model';
import { CompanyLenderPermissionModel } from '../../models/company-lender-permission.model';

@Component({
	selector: 'app-company-lenders',
    templateUrl: './company-lenders.component.html',
    styleUrls: ['./company-lenders.component.css']
})
export class CompanyLendersComponent implements OnInit {
    user: User;
    isAdmin: boolean = false;
    headerTitle: IHeaderTitle;
    @Input() companyId: string;
    companyDetailsModel: CompanyDetailsModel;
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;
    isUserAddMode = false;
    isEditMode: boolean = false;
    userTypes: UserType[];
    showUpdated: boolean;
    errors: string[];
    lendersList: CompanyLenderPermissionModel[];

	constructor(
        private companyService: CompanyService,
        private sharedService: SharedService,
        private lenderService: LendersService,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private fb: FormBuilder,
        private sortService: SortService
	) { }

	ngOnInit() {

        this.sharedService.currentUser.subscribe(user => {
            this.user = user;
            this.isAdmin = this.user.isAdmin;
        });

        this.load();
	}


    load(): void {

        this.companyService.get(this.companyId).subscribe(companyInfo => {
            this.companyDetailsModel = companyInfo;
            if (this.isAdmin) {
                this.headerTitle = {
                    title: companyInfo.legalName + ' Company Lender Permissions',
                    breadcrumbs: [{ title: 'Companies', url: ['/company'] }]
                };
            } else {
                this.headerTitle = {
                    title: companyInfo.legalName + ' Company Lender Permissions',
                };
            }
            this.getLenders(companyInfo.id);
        });
    }

    getLenders = (id) => {
        this.companyService.getCompanyLenderPermissions(id).subscribe(
            result => {
                this.lendersList = result;
            },
            error => {
                this.errors = error.errorList;
            }
        );
    }

    toggleHasAccess(lenderPermission: CompanyLenderPermissionModel): void {
        lenderPermission.companyId = this.companyId;
        lenderPermission.hasAccess = !lenderPermission.hasAccess;
        this.companyService.setLenderAccess(lenderPermission).subscribe(
            () => {
                this.load();
            },
            error => this.errors = (<Result>error).errorList
        );
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    onBack($event: any): void {
        this.location.back();
    }
}
